import { render, staticRenderFns } from "./DashboardPage.html?vue&type=template&id=7e3ad78b&scoped=true&"
import script from "./DashboardPage.ts?vue&type=script&lang=ts&"
export * from "./DashboardPage.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardPage.scss?vue&type=style&index=0&id=7e3ad78b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3ad78b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
